export const environmentAU = {
  flag: '/assets/country/au.svg',
  apiUrl: 'https://made-by-fressko.myshopify.com',
  bypassToken: '5bd1793e-8805-4d34-b969-b83c9de1cabb',
  gtmId: 'GTM-PWCLL35',
  gtagId: 'G-6N0CWX3NGD',
  klaviyoId: 'RKVT8u',
  klaviyoList: 'WPgvjR',
  localeCode: 'en-au',
  mercuryApiUrl: 'https://mercury.plutocracy.io',
  okendoSubscriberId: '21c6cb57-ccd4-46e0-88df-a8fcc39551ce',
  production: true,
  shopId: '26824933547',
  shopifyUrl: 'https://shop.au.madebyfressko.com',
  siteName: 'Made By Fressko',
  siteUrl: 'https://au.madebyfressko.com',
  storefrontKey: '1987291424857177aff5a24822ea2a4a',
  storyBlokKey: '8WmwXfOL3Vj4UL5wD5cnlQtt',
  currency: 'AUD',
  store: 'AU',
  countryEndpoints: {
    'en-GB': 'https://madebyfressko.com',
    'en-AU': 'https://au.madebyfressko.com',
    'x-default': 'https://au.madebyfressko.com',
    en: 'https://au.madebyfressko.com',
    'en-US': 'https://us.madebyfressko.com',
  } as { [key: string]: string },
};

export const environmentUS = {
  flag: '/assets/country/us.svg',
  apiUrl: 'https://made-by-fressko-usa.myshopify.com',
  bypassToken: 'dffe15f3-9428-4134-ba32-35b190f0db68',
  gtmId: 'GTM-5LZBQNC5',
  gtagId: 'G-B9X34Q2ZEZ',
  klaviyoId: 'Xqu9qB',
  klaviyoList: 'WqV5fT',
  localeCode: 'en-us',
  mercuryApiUrl: 'https://mercury.plutocracy.io',
  okendoSubscriberId: '7cc001bc-6d8a-442a-96da-3510aaa90eb8',
  production: true,
  shopId: '72365080857',
  shopifyUrl: 'https://shop.us.madebyfressko.com',
  siteName: 'Made By Fressko',
  siteUrl: 'https://us.madebyfressko.com',
  storefrontKey: '15c9981c66e007a53bb729a7a12f22a9',
  storyBlokKey: '8WmwXfOL3Vj4UL5wD5cnlQtt',
  currency: 'USD',
  store: 'US',
  countryEndpoints: {
    'en-GB': 'https://madebyfressko.com',
    'en-AU': 'https://au.madebyfressko.com',
    'x-default': 'https://au.madebyfressko.com',
    en: 'https://au.madebyfressko.com',
    'en-US': 'https://us.madebyfressko.com',
  } as { [key: string]: string },
};

export const environmentGLOBAL = {
  flag: '/assets/country/int.svg',
  apiUrl: 'https://made-by-fressko-global.myshopify.com',
  bypassToken: '211e8051-8f32-491c-9894-20d01f32eab3',
  gtmId: 'GTM-N3P336M8',
  gtagId: 'G-6SK86DNLPM',
  klaviyoId: 'T3jRdq',
  klaviyoList: 'UGmmjC',
  localeCode: 'en-gb',
  mercuryApiUrl: 'https://mercury.plutocracy.io',
  okendoSubscriberId: '0ec14912-60cb-4634-9ed8-42fc7ab9cf44',
  production: true,
  shopId: '51208388777',
  shopifyUrl: 'https://shop.madebyfressko.com',
  siteName: 'Made By Fressko',
  siteUrl: 'https://madebyfressko.com',
  storefrontKey: 'a3f424af8be3f132b31eef614c28629f',
  storyBlokKey: '8WmwXfOL3Vj4UL5wD5cnlQtt',
  currency: 'USD',

  store: 'INT',
  countryEndpoints: {
    'en-GB': 'https://madebyfressko.com',
    'en-AU': 'https://au.madebyfressko.com',
    'x-default': 'https://au.madebyfressko.com',
    en: 'https://au.madebyfressko.com',
    'en-US': 'https://us.madebyfressko.com',
  } as { [key: string]: string },
};

export const environmentWholesale = {
  flag: '/assets/country/int.svg',
  apiUrl: 'https://made-by-fressko-global.myshopify.com',
  bypassToken: '211e8051-8f32-491c-9894-20d01f32eab3',
  gtmId: 'GTM-N3P336M8',
  gtagId: 'G-6SK86DNLPM',
  klaviyoId: 'T3jRdq',
  klaviyoList: 'UGmmjC',
  localeCode: 'en-gb',
  mercuryApiUrl: 'https://mercury.plutocracy.io',
  okendoSubscriberId: '0ec14912-60cb-4634-9ed8-42fc7ab9cf44',
  production: true,
  shopId: '51208388777',
  shopifyUrl: 'https://shop.madebyfressko.com',
  siteName: 'Made By Fressko',
  siteUrl: 'https://madebyfressko.com',
  storefrontKey: 'a3f424af8be3f132b31eef614c28629f',
  storyBlokKey: '8WmwXfOL3Vj4UL5wD5cnlQtt',
  currency: 'AUD',
  store: 'AUSWHOLESALE',
  countryEndpoints: {
    'en-GB': 'https://madebyfressko.com',
    'en-AU': 'https://au.madebyfressko.com',
    'x-default': 'https://au.madebyfressko.com',
    en: 'https://au.madebyfressko.com',
    'en-US': 'https://us.madebyfressko.com',
  } as { [key: string]: string },
};
